import { render, staticRenderFns } from "./ViewMedicalCertificateDialog.vue?vue&type=template&id=2cd2c2f4"
import script from "./ViewMedicalCertificateDialog.vue?vue&type=script&lang=js"
export * from "./ViewMedicalCertificateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports